import { RouteInfo } from './sidebar.metadata';

/*
moduleName :
    desc  : ACL use
    value : API url after /api/v1/.
    expl  : url  "http://demoao.neofruition.co.in:83/api/v1/chemical/product" => "chemical/product"
*/

export const CHEMICAL_ROUTES_LIST: RouteInfo[] = [
  // {
  //   path: '/module/dashboard',
  //   title: 'Dashboard',
  //   titleKey: 'Dashboard',
  // icon: 'mdi mdi-view-dashboard',
  //   icon:'fi flaticon-network',
  //   class: '',
  //   moduleName: '',
  //   extralink: false,
  //   submenu: [],
  //   imgUrl: 'assets/images/dashboard-icon.png',
  // },
  {
    path: '',
    title: 'Masters',
    titleKey: 'Masters',
    // icon: 'mdi mdi-bookmark-plus-outline',
    icon: 'fi flaticon-network',
    class: 'has-arrow',
    moduleName: 'masters',
    imgUrl: 'assets/images/masters-icon.png',
    extralink: false,
    submenu: [
      {
        path: '/module/party/partyList',
        title: 'Business Partner',
        titleKey: 'Party',
        moduleName: 'party',
        // icon: 'mdi mdi-account-box-outline',
        icon: 'fi flaticon-network',
        class: '',
        imgUrl: '',
        extralink: false,
        submenu: [],
      },
      // {
      //   path: '/module/score-criteria-editor',
      //   title: 'Score Criteria Editor',
      //   titleKey: 'Score Criteria Editor',
      //   moduleName: '',
      //   // icon: 'mdi mdi-account-box-outline',
      //   icon: 'fi flaticon-network',
      //   class: '',
      //   imgUrl: '',
      //   extralink: false,
      //   submenu: [],
      // },
      {
        path: '/module/score-criteria-editor/critera-question-list',
        title: 'Criteria Question',
        titleKey: 'Vendor Score Configurations',
        moduleName: 'Criteriaquestion',
        // icon: 'mdi mdi-account-box-outline',
        icon: 'fi flaticon-network',
        class: '',
        imgUrl: '',
        extralink: false,
        submenu: [],
      },
      // {
      //   path: '/module/partytype',
      //   title: 'Business Associate Type',
      //   titleKey: 'partyType',
      //   imgUrl: '',
      //   moduleName: 'partyType',
      //   // icon: 'mdi mdi-settings',
      //   icon: 'fi flaticon-network',
      //   class: '',
      //   extralink: false,
      //   submenu: [],
      // },
      {
        path: '/module/categorytype',
        title: 'Category Type',
        titleKey: 'categoryType',
        imgUrl: '',
        moduleName: 'categoryType',
        // icon: 'mdi mdi-settings',
        icon: 'fi flaticon-network',
        class: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/bom',
        title: 'BOM',
        titleKey: 'bom',
        moduleName: 'chemical/bom',
        // icon: 'mdi mdi-basket-fill',
        icon: 'fi flaticon-network',
        class: '',
        imgUrl: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/product',
        title: 'Item',
        titleKey: 'Material',
        moduleName: 'chemical/item',
        // icon: 'mdi mdi-package-variant',
        icon: 'fi flaticon-network',
        class: '',
        imgUrl: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/price-matrics',
        title: 'Price Metrics',
        titleKey: 'pricemetrics',
        moduleName: 'priceMetrics',
        icon: 'fi flaticon-network',
        class: '',
        imgUrl: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/tax/tax-list',
        title: 'Tax',
        titleKey: 'tax',
        moduleName: 'tax',
        icon: 'fi flaticon-network',
        class: '',
        imgUrl: '',
        extralink: false,
        submenu: [],
      },
      // {
      //   path: '/module/productType',
      //   title: 'Material Type',
      //   titleKey: 'materialType',
      //   moduleName: 'chemical/productType',
      //   // icon: 'mdi mdi-package-variant',
      //   icon: 'fi flaticon-network',
      //   class: '',
      //   imgUrl: '',
      //   extralink: false,
      //   submenu: [],
      // },
      {
        path: '/module/supporting-material',
        title: 'Supporting Material',
        imgUrl: '',
        titleKey: 'Supporting Material',
        moduleName: 'chemical/supportingMaterial',
        // icon: 'mdi mdi-account-box-outline',
        icon: 'fi flaticon-network',
        class: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/costHead',
        title: 'Cost Head',
        titleKey: 'CostHead',
        moduleName: 'chemical/costHead',
        // icon: 'mdi mdi-cube-outline',
        icon: 'fi flaticon-network',
        class: '',
        imgUrl: '',
        extralink: false,
        submenu: [],
      },

      {
        path: '/module/uom',
        title: 'UOM',
        imgUrl: '',
        titleKey: 'UOM',
        moduleName: 'uom',
        // icon: 'mdi mdi-account-box-outline',
        icon: 'fi flaticon-network',
        class: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/segment',
        title: 'Segment',
        imgUrl: '',
        titleKey: 'Segment',
        moduleName: 'segment',
        icon: 'mdi mdi-account-box-outline',
        class: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/process',
        title: 'Process',
        titleKey: 'Process',
        imgUrl: '',
        moduleName: 'chemical/process',
        // icon: 'mdi mdi-settings',
        icon: 'fi flaticon-network',
        class: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/stock-area',
        title: 'Stock Area',
        titleKey: 'StockArea',
        imgUrl: '',
        moduleName: 'chemical/stockArea',
        icon: 'mdi mdi-settings',
        class: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/openingstock',
        title: 'Opening Stock Upload',
        titleKey: 'Opening Stock Upload',
        imgUrl: 'assets/images/account-icon.png',
        icon: 'mdi mdi-file-chart',
        class: '',
        moduleName: 'chemical/itemStock',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/processType',
        title: 'Process Type',
        titleKey: 'ProcessType',
        imgUrl: '',
        moduleName: 'processType',
        // icon: 'mdi mdi-settings',
        icon: 'fi flaticon-network',
        class: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/department',
        title: 'Department',
        titleKey: 'Department',
        imgUrl: '',
        moduleName: 'chemical/department',
        // icon: 'mdi mdi-settings',
        icon: 'fi flaticon-network',
        class: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/zone',
        title: 'Zone',
        titleKey: 'Zone',
        imgUrl: '',
        moduleName: 'zone',
        // icon: 'mdi mdi-settings',
        icon: 'fi flaticon-network',
        class: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/machine',
        title: 'Machine',
        titleKey: 'Machine',
        imgUrl: '',
        moduleName: 'chemical/machine',
        // icon: 'mdi mdi-settings',
        icon: 'fi flaticon-network',
        class: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/packing',
        title: 'Packing',
        titleKey: 'Packing',
        imgUrl: '',
        moduleName: 'chemical/packing',
        // icon: 'mdi mdi-settings',
        icon: 'fi flaticon-network',
        class: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/transport',
        title: 'Transport',
        titleKey: 'Transport',
        moduleName: 'chemical/transport',
        // icon: 'mdi mdi-truck',
        icon: 'fi flaticon-network',
        class: '',
        imgUrl: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/location',
        title: 'Location',
        titleKey: 'Location',
        imgUrl: '',
        moduleName: 'erp/location',
        // icon: 'mdi mdi-settings',
        icon: 'fi flaticon-network',
        class: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/branch',
        title: 'Branch',
        titleKey: 'Branch',
        imgUrl: '',
        moduleName: 'erp/branch',
        // icon: 'mdi mdi-settings',
        icon: 'fi flaticon-network',
        class: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/custom-field',
        title: 'Custom Field',
        titleKey: 'Custom Field',
        imgUrl: '',
        moduleName: 'customField',
        // icon: 'mdi mdi-settings',
        icon: 'fi flaticon-network',
        class: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/customParameters',
        title: 'Quality Parameters',
        titleKey: 'Quality Parameters',
        imgUrl: '',
        moduleName: 'customParam',
        // icon: 'mdi mdi-settings',
        icon: 'fi flaticon-network',
        class: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/custom-module-field',
        title: 'Custom Module Field',
        imgUrl: '',
        titleKey: 'Custom Module Field',
        moduleName: 'moduleCustomField',
        // icon: 'mdi mdi-settings',
        icon: 'fi flaticon-network',
        class: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/funnelStage',
        title: 'Funnel Stage',
        titleKey: 'crm/funnelStage',
        imgUrl: '',
        moduleName: 'crm/funnelStage',
        // icon: 'mdi mdi-settings',
        icon: 'fi flaticon-network',
        class: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/crmActivity',
        title: 'CRM Activity',
        titleKey: 'CRM Activity',
        imgUrl: '',
        moduleName: 'crm/activity',
        // icon: 'mdi mdi-settings',
        icon: 'fi flaticon-network',
        class: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/freight',
        title: 'Freight',
        titleKey: 'chemical/freight',
        imgUrl: '',
        moduleName: 'chemical/freight',
        icon: 'fi flaticon-network',
        class: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/comparision-parameter-list',
        title: 'Comparison Parameter',
        titleKey: 'Comparison Parameter',
        imgUrl: '',
        icon: 'mdi mdi-truck',
        moduleName: 'comparisonParameter',
        class: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/vehicle/vehicle-list',
        title: 'Vehicle',
        titleKey: 'Vehicle',
        moduleName: 'module/vehicle-name',
        // icon: 'fas fa-vial',
        icon: 'fi flaticon-network',
        class: '',
        imgUrl: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/driver/driver-list',
        title: 'Driver',
        titleKey: 'Driver',
        moduleName: 'module/driver-name',
        // icon: 'fas fa-vial',
        icon: 'fi flaticon-network',
        class: '',
        imgUrl: '',
        extralink: false,
        submenu: []
      },
    ],
  },
  {
    path: '',
    title: 'CRM',
    titleKey: 'CRM',
    // icon: 'mdi mdi-ticket-account',
    icon: 'fi flaticon-network',
    class: 'has-arrow',
    moduleName: 'chemical/crm',
    imgUrl: 'assets/images/dashboard-icon.png',
    extralink: false,
    submenu: [
      {
        path: '/module/funnel',
        title: 'Funnel',
        titleKey: 'Funnel',
        // icon: 'fa fa-filter',
        icon: 'fi flaticon-network',
        imgUrl: '',
        moduleName: 'crm/funnel',
        class: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/digitalplatform',
        title: 'digitalplatform',
        titleKey: 'digitalplatform',
        // icon: 'fa fa-filter',
        icon: 'fi flaticon-network',
        imgUrl: '',
        moduleName: 'crm/funnelindiamart',
        class: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/quotation',
        title: 'Quotation',
        titleKey: 'quotation',
        imgUrl: '',
        // icon: 'mdi mdi-cart-outline',
        icon: 'fi flaticon-network',
        moduleName: 'crm/quotation',
        class: '',
        extralink: false,
        submenu: [],
      },
    ],
  },
  {
    path: '',
    title: 'Supply Chain',
    titleKey: 'Account',
    // icon: 'mdi mdi-ticket-account',
    icon: 'fi flaticon-network',
    class: 'has-arrow',
    imgUrl: 'assets/images/account-icon.png',
    moduleName: 'supplyChain',
    extralink: false,
    submenu: [
      {
        path: '/module/invoices/invoice-list',
        title: 'Invoices',
        titleKey: 'Invoices',
        imgUrl: '',
        // icon: 'mdi mdi-truck',
        icon: 'fi flaticon-network',
        moduleName: 'invoices',
        class: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/purchase-order',
        title: 'Purchase Order',
        titleKey: 'Purchase Order',
        imgUrl: '',
        // icon: 'mdi mdi-truck',
        icon: 'fi flaticon-network',
        moduleName: 'chemical/purchaseOrder',
        class: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/sales-order/salesOrderList',
        title: 'Shipment Order',
        imgUrl: '',
        titleKey: 'Shipment Order',
        // icon: 'mdi mdi-cart-outline',
        icon: 'fi flaticon-network',
        moduleName: '',
        class: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/quotation-management-list',
        title: 'RFQ Management',
        titleKey: 'RFQ Management',
        imgUrl: '',
        icon: 'mdi mdi-truck',
        moduleName: 'rfqManagement',
        class: '',
        extralink: false,
        submenu: [],
      },
    ],
  },
  {
    path: '',
    title: 'Financial Statement',
    titleKey: 'financialStatement',
    // icon: 'mdi mdi-ticket-account',
    icon: 'fi flaticon-network',
    class: 'has-arrow',
    imgUrl: 'assets/images/account-icon.png',
    moduleName: 'financialStatement',
    extralink: false,
    submenu: [
      {
        path: '/module/credit-note',
        title: 'Credit Note',
        imgUrl: '',
        titleKey: '',
        // icon: 'mdi mdi-cart-outline',
        icon: 'fi flaticon-network',
        moduleName: 'creditNote',
        class: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/debit-note/',
        title: 'Debit Note',
        titleKey: 'debitNote',
        imgUrl: '',
        // icon: 'mdi mdi-truck',
        icon: 'fi flaticon-network',
        moduleName: 'debitNote',
        class: '',
        extralink: false,
        submenu: [],
      }
    ],
  },
  {
    path: '',
    title: 'Warehouse',
    titleKey: 'Warehouse',
    // icon: 'mdi mdi-factory',
    icon: 'fi flaticon-network',
    imgUrl: 'assets/images/inventory-icon.png',
    class: 'has-arrow',
    moduleName: 'inventory',
    extralink: false,
    submenu: [
      {
        path: '/module/inward-stock',
        title: 'Warehouse Stock',
        titleKey: 'Warehouse Stock',
        // icon: 'fa fa-retweet',
        icon: 'fi flaticon-network',
        imgUrl: '',
        moduleName: 'chemical/itemStock/stock',
        class: '',
        extralink: false,
        submenu: [],
        skipTitleOverwrite: true,
      },
      {
        path: '/module/pre-inward/addUpdate',
        title: 'Add Pre Inward',
        titleKey: 'preInwardAdd',
        // icon: 'fa fa-retweet',
        icon: 'fi flaticon-network',
        imgUrl: '',
        moduleName: 'chemical/preInward/addUpdate',
        class: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/pre-inward',
        title: 'Pre Inward List',
        titleKey: 'preInwardList',
        // icon: 'fa fa-retweet',
        icon: 'fi flaticon-network',
        imgUrl: '',
        moduleName: 'chemical/preInwardList',
        class: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/inward/list/addUpdate',
        title: 'Add Inward',
        titleKey: 'inwardAdd',
        // icon: 'fa fa-retweet',
        icon: 'fi flaticon-network',
        imgUrl: '',
        moduleName: 'chemical/inward/addUpdate',
        class: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/inward/list',
        title: 'Inward List',
        titleKey: 'inwardList',
        // icon: 'fa fa-retweet',
        icon: 'fi flaticon-network',
        imgUrl: '',
        moduleName: 'chemical/inwardList',
        class: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/inward-foundary/addUpdate',
        title: 'Add Inward',
        titleKey: 'inwardAdd',
        // icon: 'fa fa-retweet',
        icon: 'fi flaticon-network',
        imgUrl: '',
        moduleName: 'chemical/foundaryInward/addUpdate',
        class: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/inward-foundary',
        title: 'Inward List',
        titleKey: 'inwardList',
        // icon: 'fa fa-retweet',
        icon: 'fi flaticon-network',
        imgUrl: '',
        moduleName: 'chemical/foundaryInwardList',
        class: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/supporting-material-inward',
        title: 'Supporting Material Inward',
        titleKey: 'Supporting Material Inward',
        // icon: 'mdi mdi-beaker',
        icon: 'fi flaticon-network',
        imgUrl: '',
        moduleName: 'chemical/sm-inward',
        class: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/packing-type-inward',
        title: 'Packing Type Inward',
        titleKey: 'Packing Type Inward',
        // icon: 'mdi mdi-beaker',
        icon: 'fi flaticon-network',
        imgUrl: '',
        moduleName: 'chemical/packingTypeInward',
        class: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/materialRequest',
        title: 'Material Request',
        titleKey: 'Material Request',
        // icon: 'fa fa-request',
        icon: 'fi flaticon-network',
        imgUrl: '',
        moduleName: 'chemical/materialRequest',
        class: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/storeManagement',
        title: 'Material Allocation',
        titleKey: 'Material Allocation',
        // icon: 'fa fa-request',
        icon: 'fi flaticon-network',
        imgUrl: '',
        moduleName: 'chemical/storeManagement/allocate',
        class: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/stock-transfer',
        title: 'Stock Transfer',
        titleKey: 'StockTransfer',
        icon: 'fa fa-request',
        imgUrl: '',
        moduleName: 'chemical/stockTransfer',
        class: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/transfer-approval',
        title: 'Transfer Validation',
        titleKey: 'transferApproval',
        icon: 'fa fa-request',
        imgUrl: '',
        moduleName: 'chemical/transferApproval',
        class: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/reconciliation',
        title: 'Reconciliation',
        titleKey: 'Reconciliation',
        // icon: 'fa fa-request',
        icon: 'fi flaticon-network',
        imgUrl: '',
        moduleName: 'chemical/storeManagement/reconcile',
        class: '',
        extralink: false,
        submenu: [],
      },
    ],
  },
  {
    path: '',
    imgUrl: 'assets/images/settings-icon.png',
    // title: 'Machine asset setting',
    title: 'Machine Asset ',
    titleKey: 'MachineAssets',
    // icon: 'fa fa-link',
    icon: 'fi flaticon-network',
    moduleName: '',
    class: '',
    extralink: false,
    submenu: [
      {
        path: '/module/machine-asset-setting',
        imgUrl: 'assets/images/setting-icon.png',
        title: 'M/c - Types and Activity ',
        titleKey: 'machineSetting',
        // icon: 'mdi mdi-account',
        icon: 'fi flaticon-network',
        moduleName: 'machineAssetsActivity',
        // moduleName: '',
        class: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/machine-asset-management',
        title: 'Maintenance Activity ',
        titleKey: 'machineAssetManagement',
        // icon: 'mdi mdi-account',
        icon: 'fi flaticon-network',
        imgUrl: '',
        moduleName: 'machineAssets',
        class: '',
        extralink: false,
        submenu: [],
      },
    ],
  },
  {
    path: '',
    title: 'Modification Request',
    titleKey: 'Modification',
    // icon: 'mdi mdi-ticket-account',
    icon: 'fi flaticon-network',
    class: 'has-arrow',
    imgUrl: 'assets/images/account-icon.png',
    moduleName: 'modification',
    extralink: false,
    submenu: [
      {
        path: '/module/modification-request',
        title: 'Modification Request',
        titleKey: 'Modification Request',
        imgUrl: '',
        // icon: 'mdi mdi-truck',
        icon: 'fi flaticon-network',
        moduleName: 'modificationRequest',
        class: '',
        extralink: false,
        submenu: [],
      },
      // {
      //   path: '/module/credit-note',
      //   title: 'Credit Note',
      //   imgUrl: '',
      //   titleKey: '',
      //   // icon: 'mdi mdi-cart-outline',
      //   icon: 'fi flaticon-network',
      //   moduleName: '',
      //   class: '',
      //   extralink: false,
      //   submenu: [],
      // },
    ],
  },
  {
    path: '',
    imgUrl: 'assets/images/settings-icon.png',
    title: 'Settings',
    titleKey: 'Settings',
    // icon: 'fa fa-link',
    icon: 'fi flaticon-network',
    moduleName: '',
    class: '',
    extralink: false,
    submenu: [
      {
        path: '/module/message-templates',
        title: 'Message Templates',
        titleKey: 'Message Templates',
        // icon: 'fa fa-retweet',
        icon: 'fi flaticon-network',
        imgUrl: '',
        moduleName: 'chemical/smsTemplate',
        class: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/print-templates',
        title: 'Print Templates',
        titleKey: 'Print Templates',
        icon: 'fa fa-retweet',
        imgUrl: '',
        // moduleName: 'chemical/printTemplate',
        moduleName: 'templateConfig',
        class: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/part-code',
        title: 'Product Code',
        titleKey: 'Product Code',
        // icon: 'fa fa-retweet',
        icon: 'fi flaticon-network',
        imgUrl: '',
        moduleName: 'chemical/partCodeConfig',
        class: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/sysConfig',
        title: 'System Configuration',
        titleKey: 'System Configuration',
        // icon: 'fa fa-setting',
        icon: 'fi flaticon-network',
        imgUrl: '',
        moduleName: 'sysConfig',
        class: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/materialRequestConfig',
        title: 'Material Request Configuration',
        titleKey: 'Material Request Configuration',
        // icon: 'fa fa-retweet',
        icon: 'fi flaticon-network',
        imgUrl: '',
        moduleName: 'chemical/requestApprovalConfig',
        class: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/moduleFieldConfig',
        title: 'Module Param Config',
        titleKey: 'Module Param Config',
        // icon: 'fa fa-retweet',
        icon: 'fi flaticon-network',
        imgUrl: '',
        moduleName: 'chemical/formConfig',
        class: '',
        extralink: false,
        submenu: [],
      },
      {
        path: '/module/approval-configuration',
        title: 'Approval Configuration ',
        titleKey: 'approvalConfiguration',
        icon: 'mdi mdi-account',
        imgUrl: 'assets/images/approval-configuration.png',
        moduleName: 'approvalConfiguration',
        class: '',
        extralink: false,
        submenu: [],
      },
    ],
  },
  {
    path: '/module/reports/report',
    title: 'Report',
    titleKey: 'chemical/report',
    imgUrl: 'assets/images/reports-icon.png',
    // icon: 'mdi mdi-file-chart',
    icon: 'fi flaticon-network',
    class: '',
    moduleName: 'chemical/report',
    extralink: false,
    submenu: [],
  },
  {
    path: '/module/materialreconciliation',
    title: 'Material-Reconciliation',
    titleKey: 'chemical/materialreconciliation',
    imgUrl: 'assets/images/account-icon.png',
    icon: 'fi flaticon-network',
    class: '',
    moduleName: 'chemical/reconcile',
    extralink: false,
    submenu: [],
  },
 
  {
    path: '/module/approval-generic/approvalList',
    imgUrl: 'assets/images/approval-configuration.png',
    title: 'Approval Center',
    titleKey: 'pendingApproval',
    icon: 'fi flaticon-network',
    moduleName: 'pendingApproval',
    class: '',
    extralink: false,
    submenu: [],
  },
  {
    path: '/module/labTest',
    imgUrl: 'assets/images/labtest-icon.png',
    title: 'Lab Test',
    titleKey: 'LabTest',
    // icon: 'mdi mdi-bookmark-plus-outline',
    icon: 'fi flaticon-network',
    class: '',
    moduleName: 'chemical/labTest',
    extralink: false,
    submenu: [],
  },
  {
    path: '/module/Planning-Scheduling',
    imgUrl: 'assets/images/masters-icon.png',
    title: 'Planning & Scheduling',
    titleKey: 'Planning & Scheduling',
    // icon: 'mdi mdi-chip',
    icon: 'fi flaticon-network',
    class: '',
    moduleName: 'chemical/planning_scheduling',
    extralink: false,
    submenu: [],
  },
  {
    path: '/module/planning',
    imgUrl: 'assets/images/masters-icon.png',
    title: 'Planning',
    titleKey: 'Planning',
    // icon: 'mdi mdi-calendar',
    icon: 'fi flaticon-network',
    class: '',
    moduleName: 'chemical/only_planning',
    extralink: false,
    submenu: [],
  },
  {
    path: '/module/production-batch',
    imgUrl: 'assets/images/productionbatch-icon.png',
    title: 'Production Batch',
    titleKey: 'ProductionBatch',
    // icon: 'fa fa-cogs',
    icon: 'fi flaticon-network',
    class: '',
    moduleName: 'chemical/productionbatch',
    extralink: false,
    submenu: [],
  },
  {
    path: '/module/lot-wise-production-batch',
    imgUrl: 'assets/images/productionbatch-icon.png',
    title: 'Lot Wise Production Batch',
    titleKey: 'Lot Wise ProductionBatch',
    icon: 'fa fa-cogs',
    class: '',
    moduleName: 'chemical/lotwiseproductionbatch',
    extralink: false,
    submenu: [],
  },
  {
    path: '/module/weavingProcess/list',
    imgUrl: 'assets/images/productionbatch-icon.png',
    title: 'Weaving Process',
    titleKey: 'weavingProcess',
    icon: 'fa fa-cogs',
    class: '',
    moduleName: 'chemical/weavingProcess',
    extralink: false,
    submenu: [],
  },
  {
    path: '/module/new-production-batch',
    imgUrl: 'assets/images/productionbatch-icon.png',
    title: 'Production Batch',
    titleKey: 'NewProductionBatch',
    // icon: 'fa fa-cogs',
    icon: 'fi flaticon-network',
    class: '',
    moduleName: 'chemical/newproductionbatch',
    extralink: false,
    submenu: [],
  },
  {
    path: '/module/slittingProcess',
    imgUrl: 'assets/images/productionbatch-icon.png',
    title: 'Slitting Process',
    titleKey: 'slittingProcess',
    icon: 'fa fa-cogs',
    class: '',
    moduleName: 'slittingProcess',
    extralink: false,
    submenu: [],
  },
  {
    path: '/module/bagMakingProcess',
    imgUrl: 'assets/images/productionbatch-icon.png',
    title: 'Bag Making Process',
    titleKey: 'bagMakingProcess',
    icon: 'fa fa-cogs',
    class: '',
    moduleName: 'bagMakingProcess',
    extralink: false,
    submenu: [],
  },
  {
    path: '/module/dailyProductionMachineWise',
    imgUrl: 'assets/images/productionbatch-icon.png',
    title: 'Daily Production Machine Wise',
    titleKey: 'dailyProductionMachineWise',
    // icon: 'fa fa-cogs',
    icon: 'fi flaticon-network',
    class: '',
    moduleName: 'chemical/dailyProductionMachineWise',
    extralink: false,
    submenu: [],
  },
  {
    path: '/module/weavingProcess',
    imgUrl: 'assets/images/productionbatch-icon.png',
    title: 'Weaving Process',
    titleKey: 'weavingProcess',
    // icon: 'fa fa-cogs',
    icon: 'fi flaticon-network',
    class: '',
    moduleName: 'chemical/weavingProcess',
    extralink: false,
    submenu: [],
  },
  {
    path: '/module/daily-production',
    imgUrl: 'assets/images/productionbatch-icon.png',
    title: 'Daily Production',
    titleKey: 'DailyProduction',
    // icon: 'fa fa-clock-o',
    icon: 'fi flaticon-network',
    class: '',
    moduleName: 'chemical/dailyProduction',
    extralink: false,
    submenu: [],
  },
  {
    path: '/module/loom-vise-daily-production',
    imgUrl: 'assets/images/productionbatch-icon.png',
    title: 'DP Log',
    titleKey: 'DailyProductionLog',
    // icon: 'fa fa-file-text',
    icon: 'fi flaticon-network',
    class: '',
    moduleName: 'chemical/loom-vise-daily-production-log',
    extralink: false,
    submenu: [],
  },
  {
    path: '/module/packaging',
    imgUrl: 'assets/images/dispatch-icon.png',
    title: 'Packaging Process',
    titleKey: 'Packaging',
    icon: 'fi flaticon-network',
    class: '',
    moduleName: 'chemical/packingProcess',
    extralink: false,
    submenu: [],
  },
  {
    path: '/module/dispatch/dispatchlist',
    imgUrl: 'assets/images/dispatch-icon.png',
    title: 'Delivery',
    titleKey: 'Delivery',
    // icon: 'mdi mdi-truck',
    icon: 'fi flaticon-network',
    class: '',
    moduleName: 'chemical/dispatch',
    extralink: false,
    submenu: [],
  },
  {
    path: '/module/delivery-scheduling',
    imgUrl: 'assets/images/dispatch-icon.png',
    title: 'Delivery Scheduling',
    titleKey: 'Delivery Scheduling',
    icon: 'fi flaticon-network',
    class: '',
    moduleName: '',
    extralink: false,
    submenu: [],
    skipTitleOverwrite: true,
  },
  {
    path: '/module/shipment-tracking',
    imgUrl: 'assets/images/dispatch-icon.png',
    title: 'Shipment Tracking',
    titleKey: 'Shipment Tracking',
    // icon: 'mdi mdi-truck-delivery',
    icon: 'fi flaticon-network',
    class: '',
    moduleName: '',
    extralink: false,
    submenu: [],
  },
  {
    path: '/module/transferAndDispatch',
    imgUrl: 'assets/images/labtest-icon.png',
    title: 'Job Work',
    titleKey: 'jobWork',
    // icon: 'fa fa-cogs',
    icon: 'fi flaticon-network',
    class: '',
    moduleName: 'chemical/transfer-and-dispatch',
    extralink: false,
    submenu: [],
  },
  {
    path: '/module/cbl-to-cbl',
    imgUrl: '',
    title: 'Inter Department Transfer',
    titleKey: 'cblToCBL',
    // icon: '',
    icon: 'fi flaticon-network',
    class: '',
    moduleName: 'erp/cbl-to-cbl',
    extralink: false,
    submenu: [],
  },
 
  {
    path: '/module/user',
    imgUrl: 'assets/images/staff-icon.png',
    title: 'Staff',
    titleKey: 'Staff',
    // icon: 'mdi mdi-account',
    icon: 'fi flaticon-network',
    moduleName: 'staff',
    class: '',
    extralink: false,
    submenu: [],
  },
  {
    path: '/module/aclConfig',
    imgUrl: 'assets/images/ACLconfig-icon.png',
    title: 'ACL Config',
    titleKey: 'ACL Config',
    // icon: 'mdi mdi-account',
    icon: 'fi flaticon-network',
    moduleName: 'acl',
    class: '',
    extralink: false,
    submenu: [],
  },
];
